import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class ContentContainer extends Component {
  static propTypes = {
    style: PropTypes.shape({}),
    className: PropTypes.string,
    onClick: PropTypes.func,
  };
  static defaultProps = {
    style: {},
    className: '',
    onClick: () => {},
  };
  constructor(props) {
    super(props);
    this.state = {
      transitionDelay: this.props.transitionDelay,
      showComponent: false
    };
  }

  render() {
    return (
      <div className={`content-container-outer ${this.props.outerClassName ? this.props.outerClassName : ""}`}>
        <div onClick={this.props.onClick} style={this.props.style} className={'content-container ' + (this.state.transitionDelay ? this.state.transitionDelay : '') + ' ' + this.props.className}>
          <div className={'content-container-background'  + (this.props.darkBg ? ' darkBg' : '')} />
          {this.props.children}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/ContentContainer.js